/* src/app/core/components/mission-card-detail/mission-card-detail.component.scss */
.mission-card-detail {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 100%;
  margin: 0 auto;
  overflow: auto;
}
@media (min-width: 768px) {
  .mission-card-detail {
    max-width: 414px;
  }
}
.mission-card-detail .bg {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 50%;
  transform: translateX(-50%);
  z-index: -10;
}
.credentials {
  display: flex;
  flex-direction: row;
  align-content: center;
  flex-wrap: nowrap;
  align-items: center;
  margin-top: 25px;
}
.credentials .info {
  margin-left: 15px;
}
.credentials .info .name {
  font-weight: bold;
}
iframe {
  width: 100%;
  height: 163px;
  border-radius: 6px;
}
.profile-img img {
  width: 75px;
  height: 75px;
  border-radius: 100px;
  object-fit: cover;
}
.video {
  margin: 25px 0;
}
.audio {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  margin: 25px 0;
}
.audio audio {
  visibility: hidden;
  position: absolute;
}
.audio img {
  max-width: 118px;
  transition: all 0.3s;
}
.audio img:hover {
  cursor: pointer;
  transform: scale(1.1);
}
.mission-content {
  background: #fff;
  padding: 1rem;
  border-radius: 1.5rem;
  position: relative;
  max-width: 340px;
  max-height: 50vh;
  overflow: scroll;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 79%;
  margin: 50px auto;
}
.close-button {
  font-size: 1rem;
}
.close-button img {
  width: 2.5rem;
  height: 2.5rem;
}
.buttons {
  width: 100%;
  display: flex;
  flex-direction: row;
  right: 25px;
  bottom: 25px;
}
.buttons .blue {
  background: #4ac8f3;
}
.buttons button {
  margin: 0 15px;
}
.buttons .finish-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 15px 15px 20px;
  color: #fff;
  border-radius: 100px;
  margin: 5px 0;
  font-size: 20px;
  background: #4ac8f3;
}
.buttons .finish-button img {
  width: 24px;
  height: 24px;
  margin-left: 5px;
}
.ratings {
  margin-top: auto;
  display: flex;
  justify-content: end;
  align-items: center;
  width: 100%;
  gap: 1rem;
}
.ratings p {
  font-size: 0.7rem;
}
.ratings .rating-buttons {
  display: flex;
  align-items: center;
  gap: 1rem;
}
.ratings .rating-buttons button {
  background: none;
  transition: all 250ms;
}
.ratings .rating-buttons button:disabled {
  cursor: not-allowed;
  filter: grayscale(1);
  opacity: 0.5;
}
.ratings .rating-buttons button.active {
  scale: 1.2;
}
.ratings .rating-buttons button.active .rating-icon.like {
  color: green;
}
.ratings .rating-buttons button.active .rating-icon.dislike {
  color: red;
}
.ratings .rating-buttons button:not(.active) .rating-icon {
  color: black;
}
.ratings .rating-buttons button .rating-icon.dislike {
  transform: scaleX(-1) rotate(180deg);
  margin-top: 1.25rem;
}
.ratings .rating-buttons .rating-icon {
  width: 2rem;
  cursor: pointer;
}
/*# sourceMappingURL=mission-card-detail.component.css.map */
